import { render, staticRenderFns } from "./ContactUsView.vue?vue&type=template&id=6a466972&scoped=true"
import script from "./ContactUsView.vue?vue&type=script&lang=js"
export * from "./ContactUsView.vue?vue&type=script&lang=js"
import style0 from "./ContactUsView.vue?vue&type=style&index=0&id=6a466972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a466972",
  null
  
)

export default component.exports